import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
interface InviteCountdownProps {
  invitedAt?: string | null;
  joinStatus?: "invited" | "joined" | "rejected" | null;
  className?: string;
}

const InviteCountdown: React.FC<InviteCountdownProps> = ({
  invitedAt,
  joinStatus,
  className = "",
}) => {
  const { t } = useTranslation();
  const [remainingMs, setRemainingMs] = useState<number>(() => {
    if (!invitedAt || joinStatus !== "invited") return 0;
    const invitedTime = new Date(invitedAt).getTime();
    return Math.max(180000 - (Date.now() - invitedTime), 0);
  });

  useEffect(() => {
    if (!invitedAt || joinStatus !== "invited") {
      setRemainingMs(0);
      return;
    }

    const invitedTime = new Date(invitedAt).getTime();

    const tick = () => {
      const diff = 180000 - (Date.now() - invitedTime);
      setRemainingMs(Math.max(diff, 0));
    };

    tick();

    const interval = setInterval(() => {
      tick();
    }, 1000);

    return () => clearInterval(interval);
  }, [invitedAt, joinStatus]);

  // If participant already joined, show label instead of timer
  if (joinStatus === "joined") {
    return (
      <span className={`text-primary-orange 2xl:text-[0.521vw]/tight md:text-[10px]/tight sm:text-[5px]/tight text-[3px]/tight ${className}`}>
        {t("common.joined")}
      </span>
    );
  }

  const isExpired = remainingMs <= 0;

  if (!invitedAt || joinStatus !== "invited") {
    return (
      <span className={`text-primary-orange 2xl:text-[0.521vw]/tight md:text-[10px]/tight sm:text-[5px]/tight text-[3px]/tight ${className}`}>
        00:00
      </span>
    );
  }

  const totalSeconds = Math.floor(remainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const timeText = `${minutes.toString().padStart(1, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;

  return (
    <span
      className={`${isExpired ? "text-black-400" : "text-primary-orange"
        } 2xl:text-[0.521vw]/tight md:text-[10px]/tight sm:text-[5px]/tight text-[3px]/tight ${className}`}
    >
      {isExpired ? "00:00" : timeText}
    </span>
  );
};

export default InviteCountdown;

